import { init, loadRemote } from '@module-federation/runtime'
import { remotes, shared } from '../remotes'

init({
  remotes,
  shared
})

export const importRemoteEntry = name => loadRemote(name)
